import { KeyValue } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { CommonService } from '../../services/common.service';

@Component({
  selector: 'vrm-summary-card',
  templateUrl: './vrm-summary-card.component.html',
  styleUrls: ['./vrm-summary-card.component.scss'],
})
export class VrmSummaryCardComponent {
  @Input() cardTitle: string;
  @Input() summaryData: Array<any> = [];
  @Input() context: string;
  @Input() driverModules: any = {};
  @Input() mentorSummaryData: any = {};

  public companyHasUKLicense;
  public userHasUKLicenseEventsPermission;

  public companyHasUSLicense;
  public userHasUSLicenseEventsPermission;

  public companyHasNonUsUkLicense;
  public userHasNonUsUkLicenseEventsPermission;

  public userPermissionAtleastSummaryLicenseEvents;
  public licenseEventsHidden;

  constructor(public cService: CommonService, public translate: TranslateService) {
    this.initializeLicenceEventsPermissions();
  }

  initializeLicenceEventsPermissions() {
    this.companyHasUKLicense =
      this.cService.userProfile.companyPermissions?.permMisUKLicense === this.cService.permLevels.TRUE;
    this.userHasUKLicenseEventsPermission =
      this.cService.userProfile.userPermissions?.permUkLicense !== this.cService.permLevels.none;

    this.companyHasUSLicense =
      this.cService.userProfile.companyPermissions?.permMisUsMVR === this.cService.permLevels.TRUE;
    this.userHasUSLicenseEventsPermission =
      this.cService.userProfile.userPermissions?.permUsMvr !== this.cService.permLevels.none;

    this.companyHasNonUsUkLicense =
      this.cService.userProfile.companyPermissions?.permMisNonUsUkLicense === this.cService.permLevels.TRUE;
    this.userHasNonUsUkLicenseEventsPermission =
      this.cService.userProfile.userPermissions?.permNonUsUkLicense !== this.cService.permLevels.none;

    this.userPermissionAtleastSummaryLicenseEvents =
      this.cService.userProfile.userPermissions?.permDPRSummaryLicenseDetails === this.cService.permLevels.TRUE;

    this.licenseEventsHidden =
      ((this.companyHasUKLicense && !this.userHasUKLicenseEventsPermission) ||
        (this.companyHasUSLicense && !this.userHasUSLicenseEventsPermission) ||
        (this.companyHasNonUsUkLicense && !this.userHasNonUsUkLicenseEventsPermission)) &&
      !this.userPermissionAtleastSummaryLicenseEvents;
  }

  updateEntry(changedEntry: any, entry: any) {
    entry.isOverridden = changedEntry.isOverridden;
    entry.value = changedEntry.value;
  }

  // This is to preserve order on the keyvalue pipe
  preserveOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return 0;
  };

  getClass = (value: any): string => {
    if (typeof value === 'string') {
      if (['low', 'complete', 'agree'].includes(value.toLowerCase())) {
        return 'green-text';
      } else if (['medium', 'incomplete'].includes(value.toLowerCase())) {
        return 'amber-text';
      } else if (['high', 'not started'].includes(value.toLowerCase())) {
        return 'red-text';
      }
    }

    return '';
  };

  toggleCourseHistory = (module: any): any => {
    module.displayHistory = module.displayHistory == undefined ? true : !module.displayHistory;
  };
}
